<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

import moment from 'moment';
import FileManager from './inc/FileManager';

export default {
  page: {
    title: 'File Manager',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, FileManager },
  data() {
    return {
      title: 'File Manager',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'File Manager', active: true, },
      ],

      loading: true,
      filters: {
        paginate: 50,
        page: 1,
        total: 0,
        start_dir: '/fm',
        dir: ''
      },
    }
  },
  created() {

  },
  methods: {

  }
}
</script>

<template>
  <Layout>
    <router-view v-show="$route.params.id"></router-view>

    <div v-show="!$route.params.id">

      <PageHeader :title="title" :items="items" />

      <div class="row mt-4">
        <div class="col-12">
          <FileManager :filters="filters" @loadchange="(e) => {loading = e; (!e ? changes = e : '')}"></FileManager>
        </div>
      </div>

    </div>
  </Layout>
</template>
